"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const addMetaToState_1 = require("../helpers/addMetaToState");
const getSessionRegisteredEvent_1 = require("../helpers/getEvent/getSessionRegisteredEvent");
const getRegisterType_1 = require("../helpers/getRegisterType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function setRegisterType(command, user, state) {
    state.registerType = getRegisterType_1.getRegisterType(command, user);
}
function setLastAccessedOn(command, user, state) {
    const { timeStamp, creatorId: actorId } = command;
    const { userId } = user;
    if (actorId === userId) {
        state.lastAccessedOn = timeStamp;
    }
}
function setRegistrationFieldsInILTState(command, user, iltState) {
    const { timeStamp, formResponse = {} } = command;
    setLastAccessedOn(command, user, iltState);
    if (!iltState.startedOn) {
        iltState.startedOn = timeStamp;
    }
    iltState.deleted = false;
    iltState.updatedAt = timeStamp;
    addMetaToState_1.addMetaToState(iltState, formResponse);
}
function waitListILTSessionWithSessionState(command, user, sessionState) {
    const { timeStamp, learnerType = entity_1.ILTLearnerType.NONE } = command;
    sessionState.waitListTimeStamp = timeStamp;
    sessionState.forceComplete = false;
    sessionState.deleted = false;
    sessionState.learnerType = learnerType;
    setRegisterType(command, user, sessionState);
    setLastAccessedOn(command, user, sessionState);
}
function registerILTSessionWithSessionState(command, user, sessionState) {
    const { timeStamp, learnerType = entity_1.ILTLearnerType.NONE } = command;
    sessionState.waitListTimeStamp = null;
    sessionState.forceComplete = false;
    sessionState.deleted = false;
    sessionState.learnerType = learnerType;
    if (sessionState.completionStatus === entity_1.CompletionStatus.NOT_ATTEMPTED) {
        sessionState.startedOn = timeStamp;
    }
    setRegisterType(command, user, sessionState);
    setLastAccessedOn(command, user, sessionState);
}
function registerILTSession(command, user, sessionState) {
    const { waitList, joinWaitList } = command;
    if (waitList || joinWaitList) {
        waitListILTSessionWithSessionState(command, user, sessionState);
    }
    else {
        registerILTSessionWithSessionState(command, user, sessionState);
    }
}
function applyRegisterILTSessionsCommand(command, user, states) {
    const { contentId, sessionIds, learnerType = entity_1.ILTLearnerType.NONE } = command;
    const { userId } = user;
    const updatedStates = immer_1.produce(states, draftStates => {
        const iltState = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        setRegistrationFieldsInILTState(command, user, iltState);
        sessionIds.forEach((sessionId) => {
            const sessionState = getState_1.getStateByContentIdUserId(draftStates, sessionId, userId);
            registerILTSession(command, user, sessionState);
        });
    });
    const sessionsRegisteredEvent = getSessionRegisteredEvent_1.getSessionRegisteredEvent(command, user, contentId, sessionIds, learnerType, getRegisterType_1.getRegisterType(command, user));
    const events = [sessionsRegisteredEvent];
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyRegisterILTSessionsCommand = applyRegisterILTSessionsCommand;
//# sourceMappingURL=applyRegisterILTSessionsCommand.js.map